<template>
  <div :id="componentId" class="sp3-module-2" :style="moduleStyle">
    <div class="sp3-scroll-wrap">
      <img
        v-if="scrollImageUrl"
        class="sp3-scroll-bg"
        referrerpolicy="no-referrer"
        :src="scrollImageUrl"
      >
      <div v-else class="sp3-scroll-placeholder">请配置画卷底图</div>

      <div class="sp3-tab-bar">
        <div
          v-for="(tab, index) in displayTabList"
          :key="index"
          class="sp3-tab-item"
          :class="{ active: activeTab === index }"
          @click="handleTabClick(index)"
        >
          {{ tab.title || '标题' }}
        </div>
      </div>

      <div class="sp3-image-area">
        <div
          v-for="(imgUrl, imgIndex) in displayImageList"
          :key="imgIndex"
          class="sp3-image-frame"
          :style="frameStyle"
        >
          <img
            v-if="imgUrl"
            class="sp3-image-content"
            referrerpolicy="no-referrer"
            :src="imgUrl"
          >
          <div v-else class="sp3-image-placeholder">图片</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const DEFAULT_TAB = {
  title: '中国品牌',
  imageList: ['', '', '']
}

export default {
  name: 'SpThreeModule2',
  props: {
    componentId: {
      type: String,
      default: 'sp_three_module_2'
    }
  },
  data() {
    return {
      bgColor: '#A93738',
      scrollImageUrl: 'https://image.cbrand.com.cn//tmp/90709b7cb3444c9fdec206804c4f3863.png',
      frameImageUrl: 'https://image.cbrand.com.cn//tmp/1293429592788664fdf40b88673dc2d3.png',
      tabList: [
        { ...DEFAULT_TAB },
        { ...DEFAULT_TAB },
        { ...DEFAULT_TAB }
      ],
      activeTab: 0
    }
  },
  computed: {
    displayTabList() {
      const list = (this.tabList || []).slice(0, 6)
      if (list.length === 0) {
        return [{ ...DEFAULT_TAB }]
      }
      return list
    },
    displayImageList() {
      const tab = this.displayTabList[this.activeTab] || this.displayTabList[0] || { ...DEFAULT_TAB }
      const list = (tab.imageList || []).slice(0, 3)
      while (list.length < 3) {
        list.push('')
      }
      return list
    },
    moduleStyle() {
      return {
        backgroundColor: this.bgColor
      }
    },
    frameStyle() {
      return {
        backgroundImage: this.frameImageUrl ? `url(${this.frameImageUrl})` : 'none'
      }
    }
  },
  methods: {
    handleTabClick(index) {
      this.activeTab = index
    }
  }
}
</script>

<style scoped>
.sp3-module-2 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 35px 0 71px;
  box-sizing: border-box;
  overflow: hidden;
}

.sp3-scroll-wrap {
  position: relative;
  width: 1400px;
  height: 773px;
  margin: 0 auto;
  overflow: hidden;
}

.sp3-scroll-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-scroll-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #E0E0E0;
}

.sp3-tab-bar {
  position: absolute;
  top: 71px;
  left: 73px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1237px;
  height: 70px;
  background: linear-gradient(270deg, rgba(234, 224, 216, 0) 0%, #EBDAAB 50.17%, rgba(243, 237, 233, 0) 100%);
  border-radius: 0;
}

.sp3-tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sp3-tab-item.active {
  width: 262px;
  height: 89px;
  color: #FFFFFF;
  background: linear-gradient(270deg, #CB2F30 0%, #E96E74 100%);
  border-radius: 10px;
}

.sp3-image-area {
  position: absolute;
  top: 205px;
  left: 153px;
  display: flex;
  align-items: flex-start;
  gap: 0;
}

.sp3-image-frame {
  position: relative;
  width: 365px;
  height: 477px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  flex-shrink: 0;
}

.sp3-image-content {
  position: absolute;
  top: 35px;
  left: 43px;
  width: 262px;
  height: 376px;
  object-fit: cover;
  border-radius: 30px;
  display: block;
}

.sp3-image-placeholder {
  position: absolute;
  top: 35px;
  left: 43px;
  width: 262px;
  height: 376px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #E0E0E0;
}
</style>
